/* hs-eslint ignored failing-rules */

import { ListingPage } from 'foundations-components/transitional/components/ListingPage';
import Header from './Header';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Page({
  children
}) {
  return /*#__PURE__*/_jsx(ListingPage, {
    pageLayout: "max-width",
    headerComponent: /*#__PURE__*/_jsx(Header, {}),
    children: children
  });
}